import CardMembershipRounded from "@mui/icons-material/CardMembershipRounded";
import EmojiEventsRounded from "@mui/icons-material/EmojiEventsRounded";
import GroupRounded from "@mui/icons-material/GroupRounded";
import MailRounded from "@mui/icons-material/MailRounded";
import ReceiptLongRounded from "@mui/icons-material/ReceiptLongRounded";
import RedeemRounded from "@mui/icons-material/RedeemRounded";
import SchoolRounded from "@mui/icons-material/SchoolRounded";
import SportsRounded from "@mui/icons-material/SportsRounded";
import { Stack } from "@mui/material";
import { Page } from "../../../common/components/Page";
import { MeProfileSection } from "../components/MeProfileSection";
import { MeSectionNavigation } from "../components/MeSectionNavigation";
import { MeDestinationList } from "../components/MeDestinationList";
import type { MePageProps } from "../types";

const shortcuts = [
  { label: "Friends", to: "/me/friends", icon: <GroupRounded /> },
  { label: "Bookings & receipts", to: "/me/bookings", icon: <ReceiptLongRounded /> },
  { label: "Memberships", to: "/me/memberships", icon: <CardMembershipRounded /> },
  { label: "My classes", to: "/me/classes", icon: <SchoolRounded /> },
  { label: "Private lessons", to: "/me/lessons", icon: <SportsRounded /> },
  { label: "My competitions", to: "/compete/mine", icon: <EmojiEventsRounded /> },
  { label: "Invitations", to: "/me/invitations", icon: <MailRounded /> },
  { label: "Rewards & referrals", to: "/me/rewards", icon: <RedeemRounded /> },
];

export function MePage({ agenda, standing }: MePageProps) {
  return (
    <Page title="Activity" hideTitle narrow>
      <Stack spacing={2.5}>
        <MeProfileSection standing={standing} />
        <MeSectionNavigation active="activity" />
        {agenda}
        <MeDestinationList title="Shortcuts" items={shortcuts} />
      </Stack>
    </Page>
  );
}
